<template>
  <div v-cloak class="conten bg-white">
    <div>
        <ul class='row ft12 gary-2 tabBox '>
            <li @click="selectTab(index)" v-for="(item,index) in list" :key="index" :class="{'orangered':cur == index}">
                <span>{{item.title}}</span>
            </li>
        </ul>
        <ul class='bg-white padding0-15' v-if="courseList.length>0">
            <li class='padding20 bg-white courseBox margin15-bottom' @click="selectCourse(index)" v-for="(item,index) in courseList" :key='item.cid'>
                <p class="ft14 gray-2 padding10-bottom">{{item.itname}}</p>
                <div class="lineE0"></div>
                <p class="ft16 gray-2 padding10-0">{{item.courseTitle}}</p>
                <p class="ft12 gray-8 ">{{item.startTime}} 至 {{item.endTime}} | {{item.ccount}} 课时</p>
            </li>
        </ul>
        <learn-default v-else></learn-default>
    </div>
   <Gohome  @click="goHome"></Gohome>
  </div>
</template>
 
<script>
import { CacheModule } from '@/utils/commonUtils.js'
import LearnDefault from '@/components/default/learnDefault'
import { getLearnCenter } from '@/model/learn/learnServer';
import Gohome from '@/components/gohome/gohome'
export default {
  name: 'learningCenter',
  data(){
      return {
          cur:0,
          courseList:[],
          list:[
          ],
          
      }
  },
  components: {
      LearnDefault,
      Gohome
  },
  created(){
    let params = {
    "loginname":CacheModule.get('loginPhone')
    }
    if(!CacheModule.get('loginPhone')){
          this.goHome()
    }
      
    getLearnCenter(params).then(data =>{
        this.list = data.data
        this.courseList = this.list[this.cur].list
    }).catch(error => {
        if(error.retuCode == 5004){
            this.goHome()
        }
    })
  },
  methods: {
    goHome() {
        this.$router.replace({
            path: '/login',
        })
    },
    selectTab(index){
        this.cur = index
        this.courseList = {}

        this.courseList = this.list[index].list
    },
    selectCourse(index){
        this.$router.push({
            path: '/chapter',
            query: {
                cid:this.courseList[index].cid
            }
        })
    }
  }
}
</script>
<style scoped lang="less">
.tabBox{
    height: 38/20rem;
    padding: 0 .75rem 0 25/20rem;
    line-height:38/20rem;
    li{
        padding-right: 1.5rem;
    }
}
.courseBox{
    box-shadow:0px 0px .2rem 0px rgba(0, 0, 0, 0.25);
    border-radius:5px;
}
</style>